module.exports = "{\n  prepareVoiceMessage\n}\n"